(function() {
  'use strict';

  angular
    .module('iqxCore')
    .service('menuSvc', menuSvc)

  function menuSvc(ApplicationSvc, userRightsSvc, switchesSvc){
    var svc = this

    svc.menu = []
    svc.update = update
    svc.clear = clear

    ///////////

    function update(){
      clear()
      angular.forEach(
        iqxWebBuildMenu(ApplicationSvc.currentUser.UserClass.toLowerCase()).items,
        function(value){
          if(value.rights && !userRightsSvc.check(value.rights)){
            return
          }
          if(value.switches && !switchesSvc.check(value.switches)){
            return
          }
          if(value.params && !configSvc.check(value.params)){
            return
          }

          if(value.subMenu){
            var newSubMenuItems = []
            angular.forEach(value.subMenu.items, function(item, key){
                if(item.rights && !userRightsSvc.check(item.rights)){
                  return
                }
                if(item.switches && !switchesSvc.check(item.switches)){
                  return
                }
                if(item.params && !configSvc.check(item.params)){
                  return
                }
                newSubMenuItems.push(item)
            })
            value.subMenu.items = newSubMenuItems
          }

          svc.menu.push(value)
        }
      )
    }

    function clear(){
      svc.menu.length = 0
    }

  }

})()
